import React, { useEffect } from 'react';
import ContactUs from 'components/UI/ContactUs';
import QuoteBasicInfo from 'components/BusinessLogic/Quotes/QuoteBasicInfo/Loadable';
import Skeleton from 'components/UI/Skeleton';
import { connect } from 'react-redux';
import _ from 'lodash';
import { loadRequest, requestDetailsIncludes, requestHeaderIncludes } from 'store/dispatchers/requests.dispatchers';
import { buildMetaRequestSelector, buildRequestSelector } from 'store/selectors/requests.selector';
import PropTypes from 'prop-types';
import { containsIncludes } from 'store/dispatchers/helpers';

function RequestHeaders({
    requestId, getRequest, metaRequest, request, isB2cPage,
})
{
    function parseConciergeEmailFromUser({ userEmails, conciergeGroups })
    {
        let defaultEmail = userEmails?.find((email) => email.default);
        if (defaultEmail)
        {
            return defaultEmail.email;
        }

        defaultEmail = _.get(userEmails, '[0].email');
        if (defaultEmail)
        {
            return defaultEmail;
        }

        return _.get(conciergeGroups, '[0].concierges[0].emails[0].email', null);
    }

    const loadData = async () =>
    {
        if (_.isEmpty(request) || !containsIncludes(requestHeaderIncludes, metaRequest?.loadedIncludes))
        {
            getRequest(requestId);
        }
    };

    useEffect(() =>
    {
        loadData();
    }, []);

    return (

        <div className="tw-grid tw-grid-cols-5 tw-gap-3 tw-mt-6">
            <div className="max-md:tw-col-span-4 max-sm:tw-col-span-5 tw-col-span-3 tw-grid tw-gap-3">
                <div className="max-2xl:tw-max-w-[520px] max-sm:tw-max-w-full">
                    {
                        !request.id ? (
                            <Skeleton type="card" />
                        ) : (
                            <QuoteBasicInfo
                                isB2cPage={isB2cPage}
                                requestId={request.id}
                            />
                        )
                    }
                </div>
            </div>
            <div className="max-md:tw-col-span-1 tw-col-span-2 tw-min-h-full">
                <ContactUs conciergeEmail={parseConciergeEmailFromUser(request?.user)} isB2cPage={isB2cPage} className="tw-mr-0 tw-ml-auto tw-min-h-full" reference={`Quote ${requestId}`} />
            </div>
        </div>
    );
}

RequestHeaders.defaultProps = {
    isB2cPage: false,
};

RequestHeaders.propTypes = {
    requestId: PropTypes.number.isRequired,
    isB2cPage: PropTypes.bool,
    getRequest: PropTypes.func,
    metaRequest: PropTypes.any,
    request: PropTypes.shape({
        id: PropTypes.number,
        user: PropTypes.shape({
            userEmails: PropTypes.array,
            conciergeGroups: PropTypes.array,
        }),
    }),
};

const mapStateToProps = () =>
{
    const requestSelector = buildRequestSelector();
    const metaRequestSelector = buildMetaRequestSelector();

    return (state, props) =>
    {
        const requestId = parseInt(props.requestId, 10);
        return {
            request: requestSelector(state, requestId),
            metaRequest: metaRequestSelector(state, requestId),
        };
    };
};

const mapDispatchToProps = (dispatch) => ({
    getRequest(requestId)
    {
        return dispatch(loadRequest(requestId, requestDetailsIncludes));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestHeaders);
